import { Layout as AntdLayout } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type LayoutProps = Partial<GetProps<typeof AntdLayout>>;
export type ContentProps = Partial<GetProps<typeof AntdLayout.Content>>;
export type HeaderProps = Partial<GetProps<typeof AntdLayout.Header>>;
export type FooterProps = Partial<GetProps<typeof AntdLayout.Footer>>;

export const layoutPrefixCls = `${CMP_PREFIX}-layout`;

export const Layout = ({ ...props }: LayoutProps) => {
  return <AntdLayout {...props} />;
};

export const Content = ({ ...props }: ContentProps) => {
  return <AntdLayout.Content {...props} />;
};

export const Header = ({ ...props }: HeaderProps) => {
  return <AntdLayout.Header {...props} />;
};

export const Footer = ({ ...props }: FooterProps) => {
  return <AntdLayout.Footer {...props} />;
};
